import React, {useContext, useEffect, useRef, useState} from "react";
import BetterStandsContext from "../../../Components/Contexts/Management/BetterStandsContext";
import axios from "axios";
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import { useTranslation } from "react-i18next";

const DOFForm = ({ isOpen, toggle, formId, sahaFormId, selectedData }) => {
  const { t } = useTranslation("saha");
    const [search, setSearch] = useState('');
    const [denetmenId, setDenetmenId] = useState("0");
    const [photo, setPhoto] = useState(null);
    const fileInputRef = useRef(null);
    const { activeFairId, fetchActiveStands, getPostHeader } = useContext(BetterStandsContext);
    const [captureMethod, setCaptureMethod] = useState('environment');
    const [triggerFileInput, setTriggerFileInput] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        async function run() {
            const userId = localStorage.getItem('userId');
            if (userId) {
                setDenetmenId(userId);
            } else {
                console.error("User ID not found in localStorage");
            }
        }
        run();
    }, [isOpen]);

    useEffect(() => {
        if (denetmenId) {
            fetchActiveStands(0, 10, null, search); // search parametresini ekledik
        }
    }, [denetmenId, search, fetchActiveStands]);

    useEffect(() => {
        if (triggerFileInput && fileInputRef.current) {
            fileInputRef.current.click();
            setTriggerFileInput(false);
        }
    }, [triggerFileInput]);

    const handleSubmitU = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsSaving(true);
        const formData = new FormData();
        formData.append('form_type_id', formId);
        formData.append('user_id', denetmenId);
        formData.append('fuar_id', activeFairId);

        if (photo) {
            formData.append('photo', photo);
        }

        try{
            const postRequest = axios.post('https://fds.sakagrup.com/Saha/xCloseUyumsuzluk/'+sahaFormId, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            postRequest.then((response) => {
                console.log('Form submission successful:', response);
                setPhoto(null);
            });
        } catch (error) {
            console.error('Error submitting form:', error);
        }finally {
            setTimeout(() => {
                setIsSaving(false);
                toggle();
            }, 500);
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setPhoto(e.target.files[0]);
        }
    };

    const handleCameraClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{t("dofForm.dofOlustur")}</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmitU}>
                    <FormGroup>
                        <Label for="photoUpload">{t("dofForm.fotograf")}</Label>
                        <Input
                            type="file"
                            name="photo"
                            id="photoUpload"
                            accept="image/*"
                            capture={captureMethod}
                            onChange={handleFileChange}
                            innerRef={fileInputRef}
                            style={{ display: 'none' }}
                            disabled={isSaving}
                        />
                        <div className="d-flex gap-2">
                            <Button
                                type="button"
                                color="secondary"
                                onClick={() => {
                                    setCaptureMethod('environment');
                                    //fileInputRef.current.click();
                                    setTriggerFileInput(true);
                                }}
                                disabled={isSaving}
                            >
                                {t("dofForm.kamera")}
                            </Button>
                            <Button
                                type="button"
                                color="info"
                                onClick={() => {
                                    setCaptureMethod(null);
                                    //fileInputRef.current.click();
                                    setTriggerFileInput(true);
                                }}
                                disabled={isSaving}
                            >
                                {t("dofForm.dosyaSec")}
                            </Button>
                        </div>
                        {photo && <div className="mt-2">{t("dofForm.secilenDosya")}{" "}{photo.name}</div>}
                    </FormGroup>
                    <Button color="primary" type="submit" disabled={isSaving}>
                        {isSaving ? t("dofForm.kaydediliyor") : t("common:kaydet")}
                    </Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default DOFForm;